import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { InstrumentoMedicao, PaginatedResponse } from '../types'

export function useInstrumentoList() {
  return useQuery({
    queryKey: ['instrumentos'],
    queryFn: async () => {
      const r = await api.get<PaginatedResponse<InstrumentoMedicao>>('/instrumentos/', {
        params: { page_size: 200 },
      })
      return r.data
    },
    staleTime: 1000 * 60 * 5,
  })
}

/** Apenas instrumentos ativos com calibração não vencida — pra uso em checklist. */
export function useInstrumentosUtilizaveis() {
  const list = useInstrumentoList()
  const filtrados = list.data?.results.filter((i) => i.ativo && !i.calibracao_vencida) ?? []
  return { ...list, data: filtrados }
}
